<template>
    <div id="app">
        <Header-card></Header-card>
        <router-view />
        <Base-footer></Base-footer>
    </div>
</template>

<script>
export default {
    name: 'App',
    mounted () {

    }
}
</script>

<style>
html,
body {
    padding: 0;
    margin: 0;
    background-color: #ffffff;
    min-width: 1300px;
}
.base_div {
    width: 100%;
    max-width: 1300px;
    margin: 0 auto;
}
.base_text {
    font-size: 20px;
    color: #3c3c3c;
    font-weight: 300;
    line-height: 38px;
}
.base_div_title {
    padding: 50px 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue